module.exports = __webpack_public_path__ + "media/mutter_1.1a.96db6f49.mp3";